import { useCallback } from 'react';
import { useStoreActions } from '~/contexts';
export const useSetAuthToken = ()=>{
    const { setAuthToken, setIsSwitchingBusiness } = useStoreActions();
    return useCallback(async (authToken)=>{
        setIsSwitchingBusiness(true);
        try {
            await setAuthToken(authToken);
        } finally{
            setIsSwitchingBusiness(false);
        }
    }, [
        setAuthToken,
        setIsSwitchingBusiness
    ]);
};
